export default __webpack_public_path__ + "static/media/icon-logout-blue.f09a0dd0.svg";